<xi-generic-modal
  [customPadding]="{ top: '0', right: '0', bottom: '0', left: '0' }"
  [isVisible]="true"
  maxWidth="660px"
  (onClose)="cancel()"
  *transloco="let t; read: 'widget-group-create-component'"
>
  <div slot="children">
    <xi-basic-tile [hasTopBar]="false" [stretch]="true" [isInteractive]="false">
      <div slot="children">
        <div class="xi-modal__container widget-group-create__container">
          <h2 class="xi-modal__title">
            {{ isRename ? t('rename') : t('create') }}
          </h2>

          <div class="xi-modal__content">
            <form autocomplete="off">
              <div class="xi-input-field-wrapper">
                <xi-input-field
                  placeholder="{{ t('placeholder') }}"
                  label="{{ t('group-name') }}"
                  name="Group Name"
                  [(ngModel)]="name"
                  required
                  [status]="widgetGroupNameStatus"
                  [prePopulateStatus]="true"
                  (onChange)="onValidateWidgetGroupName()"
                  appAutoFocus="xiInput"
                ></xi-input-field>
              </div>
              <div class="color-picker-wrapper">
                <label class="kxi-input-label kxi-normal-contrast">{{ t('swatch') }}</label>
                <xi-color-picker
                  [direction]="6"
                  [preselectedColors]="projectPalette"
                  [selectedColor]="widgetGroupColor"
                  (onColorChange)="widgetGroupColorChange$.next($event.detail.color)"
                >
                </xi-color-picker>
              </div>
            </form>
          </div>

          <div class="xi-modal__actions">
            <div class="xi-loader-button-container">
              <xi-default-button
                text="{{ t('cancel') }}"
                fill="text"
                (onClick)="cancel()"
              ></xi-default-button>
              <xi-default-button
                [text]="isRename ? t('save') : t('next')"
                buttonSize="large"
                [disabled]="!canConfirm()"
                (onClick)="confirm()"
              ></xi-default-button>
              @if (isLoading.confirm) {
                <div class="xi-loader-container__inline-overlay">
                  <xi-animation
                    [height]="100"
                    [width]="100"
                    [loop]="true"
                    animation="cx_loader"
                  ></xi-animation>
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    </xi-basic-tile>
  </div>
</xi-generic-modal>
